import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useNavigationStore = defineStore('navigation', () => {
  const isNavigating = ref(false)
  const progress = ref(0)

  let tickInterval: ReturnType<typeof setInterval> | null = null

  function startNavigation(): void {
    if (tickInterval !== null) {
      clearInterval(tickInterval)
      tickInterval = null
    }
    progress.value = 0
    isNavigating.value = true
    tickInterval = setInterval(() => {
      progress.value += (85 - progress.value) * 0.1
    }, 50)
  }

  function endNavigation(): void {
    if (tickInterval !== null) {
      clearInterval(tickInterval)
      tickInterval = null
    }
    isNavigating.value = false
    progress.value = 100
  }

  return { isNavigating, progress, startNavigation, endNavigation }
})
